import React, { Component } from 'react'
import { Button, Icon, Radio, notification } from 'antd'
import { omisekey, sellername, currency } from '../../config'
import { TaxType } from '../../models/transection'
class Omiseprompay extends Component {

  constructor(props) {
    super(props)

    this.state = {
      btnLoginloading: false
    }

    this.callPayment = this.callPayment.bind(this)

  }

  componentDidMount() {
    const OmiseCard = window.OmiseCard

    OmiseCard.configure({
      publicKey: omisekey,
      frameLabel: sellername,
    })

    this.setState({
      OmiseCreditCard: OmiseCard
    })
  }

  async callPayment(e) {
    e.preventDefault()
    try {
      this.setState({ btnLoginloading: true })
      if (!this.props.data.mobile || !this.props.data.name || !this.props.data.idcard) {
        this.props.handleErrorMessage("Please fill up this form.")
        this.setState({ btnLoginloading: false })
        return
      }
      if (this.props.data.mobile.length !== 10) {
        this.props.handleErrorMessage("Mobile number must be 10 digits.")
        this.setState({ btnLoginloading: false })
        return
      }
      if (this.props.data.idcard.length < 10 || this.props.data.idcard.length > 13) {
        this.props.handleErrorMessage("ID card must be 10-13 digits.")
        this.setState({ btnLoginloading: false })
        return
      }
      if (this.props.data.typetax == TaxType.CORPORATE) {
        if (!this.props.data.address ||
          !this.props.data.branch ||
          !this.props.data.district ||
          !this.props.data.province ||
          !this.props.data.post ||
          !this.props.data.subdistrict) {

          this.props.handleErrorMessage("Please fill up this form.")
          this.setState({ btnLoginloading: false })
          return
        }
      }
      await this.props.ProcessPayment()
      this.setState({ btnLoginloading: true })
    } catch (error) {
      this.setState({ btnLoginloading: false })
    }
  }
  beforeSubmit(e) {
    e.preventDefault()
  }

  render() {
    let { btnLoginloading } = this.state

    return (
      <form id="CheckOutWithpromptpay" onSubmit={this.beforeSubmit}>
        <span style={{ color: "red" }}>{this.props.data.errormessage}</span>
        <Button
          style={{ backgroundColor: "#EA7326", color: "#fff" }}
          loading={btnLoginloading}
          //   disabled={!this.props.data.mobile || !this.props.data.name || !this.props.data.idcard}
          onClick={this.callPayment}
        >
          Payment
        </Button>
      </form>
      /*  <form id="CheckOutWithpromptpay" onSubmit={this.beforeSubmit}>
           <Button style={{}} loading={btnLoginloading} onClick={this.callOmise}>Pay with promptpay</Button>
       </form> */
    )
  }
}

export default Omiseprompay